import { motion, useScroll, useSpring } from "framer-motion";

// Slim scroll-progress bar rendered on top of the fixed header stack.
// Uses framer-motion useScroll so it stays in sync with Lenis smooth scroll.
export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 24,
    mass: 0.35,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      aria-hidden="true"
      style={{ scaleX, transformOrigin: "0% 50%" }}
      className="fixed top-0 left-0 right-0 z-[60] h-[2px] bg-accent"
    />
  );
}
